import { Nav } from "./components/nav";
import { FAQ } from "./components/faq";
import { ContactForm } from "./components/contact-form";
import { Blog } from "./pages/blog";
import { HorizontalSlider } from "./components/horizontal-slider";
import { Animations } from "./components/animations";

// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

class App {
	constructor() {
		const nav = new Nav();

		if (document.querySelector(".page-id-14") || document.querySelector(".page-id-65")) {
			const animations = new Animations();
		}

		if (document.querySelector(".faq-items")) {
			const faq = new FAQ();
		}

		if (document.querySelector(".template-contact")) {
			const contactForm = new ContactForm();
		}

		if (
			document.querySelector(".template-blog") ||
			document.querySelector(".template-search")
		) {
			const blog = new Blog();
		}

		if (document.querySelector(".impacts")) {
			const horizontalSlider = new HorizontalSlider();
		}
	}
}

window.onload = function() {
	let app = new App();
};
